export default "Hvem spiser hvem? Bliv sammen klogere på, hvem der spiser hvem via en lille illustrativ mini- fødekæde.\n";